import React, { Fragment, useEffect, useState } from "react";

//*MUI
import { Box, Divider } from "@mui/material";

//*Redux
import { useDispatch, useSelector } from "react-redux";
import action from "../../../Redux Store/actions";

//*files
import cssClasses from "./UnitChanges.module.css";
import DropDown from "../../../Subcomponents/DropDown";
import SearchBar from "../../../Subcomponents/Search";
import Datagrid from "../../../Subcomponents/Datagrid";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
import { getAllEventsChangeUnitRequests } from "../../../Services/Event";
import SiteVisitIcon from "../../../Assets/Images/Common/noProjectFound.svg";
import { useParams } from "react-router-dom";

function UnitChanges() {
  const dispatch = useDispatch();
  let loggedInUser = {};
  const { eventID } = useParams();
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [EventChangeUnitData, setEventChangeUnitData] = useState([]);
  const [NoChangeRequestPresent, setNoChangeRequestPresent] = useState(null);

  useEffect(() => {
    dispatch(action.activeMenu("unitchangerequests"));
    getAllUnitChangeRequests(false);
  }, []);

  const CpColumns = [
    {
      field: "LeadName",
      headerName: "Lead Name",
      width: 220,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.innerTitle}
           
          >
            {params?.row?.allotmentPaymentId.leadId?.personId?.name
              ? params?.row?.allotmentPaymentId?.leadId?.personId?.name
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "CPName",
      headerName: "CP Name",
      width: 300,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.innerTitle}
            
          >
            {params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName
              ? params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "SalesRepresentative",
      headerName: "Sales Representative",
      width: 300,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.innerTitle}
            
          >
            {params?.row?.userId?.name ? params?.row?.userId?.name : "-"}
          </Box>
        );
      },
    },
    {
      field: "Amount",
      headerName: "Amount Paid",
      width: 100,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.allotmentPaymentId?.paidAmount}
          </Box>
        );
      },
    },
    {
      field: "ProjectName",
      headerName: "Project Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.innerTitle}
           
          >
            {params?.row?.allotmentPaymentId?.unitId?.projectId?.projectName}
          </Box>
        );
      },
    },
    {
      field: "CurrentUnitDetails",
      headerName: "Current Unit Details",
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {/* {params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              ? params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              : "-"}{" "} */}
              {params?.row?.allotmentPaymentId?.unitId?.wingId?.displayName ? params?.row?.allotmentPaymentId?.unitId?.wingId?.displayName : params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              ? params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              : "-"}{" "}
            -
            {params?.row?.allotmentPaymentId?.unitId?.unitNo
              ? params?.row?.allotmentPaymentId?.unitId?.unitNo
              : "-"}
            <Box m={1} component={"span"}>
              {" "}
              |{" "}
            </Box>
            {params?.row?.allotmentPaymentId?.unitId?.inventoryTypeId?.type}
          </Box>
        );
      },
    },
    {
      field: "Changed Unit Details",
      headerName: "Changed Unit Details",
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {/* {params?.row?.allotmentPaymentId?.unitId} */}

            {/* {params.row.allotmentPaymentId} */}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        return (
          <ThreeDotsMenu
            list={["Accept", "Reject"]}
            selectedValue={(e) => {
              console.log(e);
              // if (e === 'one') {
              //   navigate('/home/Sustenance/ConfigureEvent/Inventory');
              // }
            }}
          />
        );
      },
    },
  ];

  function getAllUnitChangeRequests(pageNumber, merge) {
    getAllEventsChangeUnitRequests(
      eventID,
      // pageNumber * pageSize,
      // pageNumber * pageSize + pageSize - 1
    )
      .then((res) => {
        console.log("Events-change-unit-requests", res);

        if (res.count > 0) {
          setNoChangeRequestPresent(true);
        } else {
          setNoChangeRequestPresent(false);
        }

        const Data = res.data.map((el, index) => ({
          ...el,
          id: el?.changeUnitRequestId,
          index: index,
        }));

        if (merge) {
          setEventChangeUnitData((pre) => [...pre, ...Data]);
        } else {
          setEventChangeUnitData([...Data]);
        }
      })
      .catch((err) => {
        console.log("Change-Unit-Table-error", err);
      });
  }

  function pageChanged(e) {
    console.log(e);
  }
  return (
    <Box className={cssClasses.Container}>
      <Box mb={2}>
        <Box className={cssClasses.HeaderTitle}>Change Unit Requests</Box>
        {/* <Box className={cssClasses.SubTitle}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </Box> */}
      </Box>

      <Divider />

      <Box className={cssClasses.SubHeaderTitle} margin={"2rem 0"}>
        Select Requests
      </Box>

      {NoChangeRequestPresent === true && (
        <Fragment>
          <Box margin={"2rem 0"}>
            <Box className={cssClasses.SubContainer}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.SubTitle}>Filter by</Box>
                <Box width={"250px"}>
                  <DropDown
                    list={["All", "ProjectA"]}
                    style={{
                      background: "#F2F4F7",
                      selectedColor: "#667085",
                    }}
                    //   selectedValue={leadObj.leadStatus}
                    // onChangeSelect={onChangeSelect}
                  />
                </Box>
              </Box>

              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.SubTitle} marginLeft={"2rem"}>
                  Sort by
                </Box>
                <Box width={"250px"} margin={"0 2rem"}>
                  <DropDown
                    list={[
                      "Name A -> Z",
                      "Name Z -> A",
                      "latest first",
                      "oldest first",
                    ]}
                    style={{
                      background: "#FFFFFF",
                      selectedColor: "#667085",
                    }}
                    //   selectedValue={leadObj.leadStatus}
                    // onChangeSelect={onChangeSelect}
                  />
                </Box>
              </Box>

              <Box marginLeft={"auto"} marginTop={"2.5rem"}>
                <SearchBar placeholder={"Search by event name"} />
              </Box>
            </Box>
          </Box>

          <Box className={cssClasses.GridWrapper}>
            <Datagrid
              rows={EventChangeUnitData}
              columns={CpColumns}
              hideFooter={false}
              pageChanged={pageChanged}
            />
          </Box>
        </Fragment>
      )}

      {NoChangeRequestPresent === false && (
        <Box>
          <Box width={"100%"} height={"100%"}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={SiteVisitIcon} alt="No Change Unit Requests Yet" />
              </Box>
              <Box className={cssClasses.emptyTitle}>
                No Change Unit Requests were found
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default UnitChanges;
